module.exports = __webpack_public_path__ + "img/index_slide_main2.e83fd1df.jpg";